<template>
  <div class="flex flex-row w-full">
    <div class="flex-1">
      <router-link
        :to="{ name: option.path }"
        :class="setTheme"
        class="focus:outline-none group flex rounded-md items-center w-full px-2 py-2 text-sm"
      >
        {{ option.name }}
      </router-link>
    </div>
    <div @click="handleClick" class="focus:outline-none group flex flex-none items-center">
      <base-icon v-if="icon" :name="icon"  class="mr-2 ml-2" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'link-item',
  props: {
    option: {
      type: [Array, Object],
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    method: {
      type: Function
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    setTheme: function () {
      return {
        'bg-white dark:bg-darkblue dark:text-darkblue-200 lg:dark:bg-darkblue-900 hover:bg-primary-50 dark:hover:bg-darkblue hover:text-primary active:bg-primary-100 dark:active:bg-darkblue-600 dark:focus:bg-darkblue-600 dark:focus:text-primary':
          this.theme === 'light',
        'bg-secondary text-white hover:bg-secondary-900 active:bg-secondary focus:bg-secondary-900':
          this.theme === 'dark'
      }
    }
  },
  data () {
    return {
      id: this.option.id
    }
  },
  methods: {
    handleClick: function (event) {
      this.$emit('iconClick', this.option.id)
    }
  }
}
</script>

<style lang="scss" scoped></style>
